module.exports = __webpack_public_path__ + "static/media/logoSeiska.b02a3c7a.svg";